import { useState } from "react";
import { ButtonGroup, Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { Href, SplitDropdownTitle } from "../../../Constants/Constants";
import { SplitDropdownData, SplitDropdownSubTitle } from "../../../Data/UiKits/Dropdown";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SplitDropdown = () => {
  const [open, setOpen] = useState(false);

  return (
    <Col sm="12" xl="12">
      <Card>
        <CommonCardHeader title={SplitDropdownTitle} span={SplitDropdownSubTitle} />
        <CardBody className="dropdown-basic me-0">
          <div className="common-flex">
            {SplitDropdownData &&
              SplitDropdownData.map((data, index) => (
                <ButtonGroup key={index}>
                  <Btn outline color={data.class}>
                    {data.text}
                  </Btn>
                  <Dropdown className="separated-btn" isOpen={open} toggle={() => setOpen(!open)} direction="down">
                    <DropdownToggle color={data.class}>
                      <i className="icofont icofont-arrow-down"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-content">
                      {data.menulist &&
                        data.menulist.map((item, index) => (
                          <DropdownItem href={Href} key={index}>
                            {item}
                          </DropdownItem>
                        ))}
                    </DropdownMenu>
                  </Dropdown>
                </ButtonGroup>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SplitDropdown;
